import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import {
	PARAM_LABEL_USER
} from 'src/app/core/services/constant/constants.service';
import {
	FormArray,
	FormBuilder,
	FormControl,
	FormGroup,
} from '@angular/forms';
import { BonCommande, Cible, CibleString } from 'src/app/shared/models/bonCommande';
import { Service } from 'src/app/shared/models/service';
import { Region } from 'src/app/shared/models/region';
import { BonCommandeReference } from 'src/app/shared/models/bonCommandeReference';
import { BonCommandeService } from 'src/app/shared/models/bonCommandeService';
import { isEmpty } from 'lodash';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-bonCommande-form',
	templateUrl: './bonCommande-form.component.html',
	styleUrls: ['./bonCommande-form.component.scss']
})
export class BonCommandeFormComponent implements OnInit {
	/**
	 * BonCommande
	 */
	@Input() bonCommande: BonCommande;

	/**
	 * Vrai si formulaire d'ajout, faux sinon (formulaire de détail)
	 */
	@Input() isAddForm: boolean;

	/**
	 * Addresse sélectionner dans le typeahead
	 */
	@Input() isAddressSelected: { value: boolean };

	/**
	 * Booleen indiquant si il s'agit de l'addresse par défaut ou non
	 */
	@Input() isAddressDefault: { value: boolean };

	/**
	 * Formulaire angular
	 */
	@Input() form: FormGroup;

	/**
	 * Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	 */
	@Input() isValidateButtonClicked: { value: boolean };

	/**
	 * Signal émis lors de l'envoi du formulaire pour que la sauvegarde du formulaire ce fasse dans le composant parent
	 */
	@Output() sendForm: EventEmitter<any> = new EventEmitter();

	/**
	 * Signal émis pour que la modal soit fermée
	 */
	@Output() hideModal: EventEmitter<any> = new EventEmitter();

	LABEL_USER: string;
	MAX_NAME_CHAR = 25;

	listReference: BonCommandeReference[];
	listService: Service[];
	listSelectedService: Service[];
	listSelectedBonCommandeService: BonCommandeService[];

	listRegion: Region[];
	showErrorMsgPourcentage = false;

	public CibleStringEnum = CibleString;
	public CibleEnum = Cible;

	constructor(
		private facade: FacadeService,
		private logger: LogService,
		private fb: FormBuilder,
	) {}

	ngOnInit(): void {
		if (this.bonCommande) {
			this.listReference = this.bonCommande.references != null ? [...this.bonCommande.references] : [];
			console.log(this.listReference);

			this.LABEL_USER =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_USER
			);

			this.facade.serviceService.getAllService().subscribe({
				next: (val) => {
					this.listService = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.regionService.getAllRegion().subscribe({
				next: (val) => {
					this.listRegion = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.listSelectedBonCommandeService = this.bonCommande.services != null ? [...this.bonCommande.services] : [];
			this.listSelectedService = [];
			this.listSelectedBonCommandeService.forEach(f => {
				this.listSelectedService.push(f.service);
			});

			(this.form.get('services') as FormArray).removeAt(0);
			(this.form.get('references') as FormArray).removeAt(0);

			if (!this.isAddForm) {
				console.log(this.bonCommande.dateDebut)
				this.form = this.fb.group({
					marche: this.bonCommande.marche,
					description: this.bonCommande.description,
					lot: this.bonCommande.lot,
					descriptionLot: this.bonCommande.descriptionLot,
					commande: this.bonCommande.commande || '',
					dateDebut: this.bonCommande.dateDebut !== null && this.bonCommande.dateDebut !== ''
					? new Date(this.bonCommande.dateDebut)
					: null,
					dateFin: this.bonCommande.dateFin !== null && this.bonCommande.dateFin !== ''
					? new Date(this.bonCommande.dateFin)
					: null,
					responsable: this.bonCommande.responsable,
					adjudicateur: this.bonCommande.adjudicateur,
					adresseFacturation: this.bonCommande.adresseFacturation,
					titulaire: this.bonCommande.titulaire,
					region: this.bonCommande.region?.id,
					references: this.fb.array(this.listReference?.map(r => this.fb.group(r))),
					services: this.fb.array(this.listSelectedBonCommandeService?.map(r => this.fb.group(r)))
				});

				console.log(this.form);
			}

		}
	}

	/**
	 * Méthode d'envoie de formulaire, si celui est valide stock les données et envoie un signal au composant parent
	 */
	submitForm() {
		if (this.form.valid) {
			let totalPourcentage = 0;
			this.form.value.services.forEach(e => {
				totalPourcentage = totalPourcentage + e.pourcentageCharge;
			})
			if(this.form.value.services.length>0 &&  totalPourcentage != 100) {
				this.showErrorMsgPourcentage = true;
			}else{
				//this.bonCommande.services = this.listSelectedBonCommandeService;
				this.bonCommande.services = this.form.value.services;
				this.bonCommande.references = this.form.value.references;
				this.bonCommande.marche = this.form.value.marche;
				this.bonCommande.description = this.form.value.description;
				this.bonCommande.lot = this.form.get('lot').value;
				this.bonCommande.descriptionLot = this.form.get('descriptionLot').value;
				this.bonCommande.commande = this.form.get('commande').value;
				this.bonCommande.dateDebut = new Date(new Date(this.form.get('dateDebut').value).setHours(12,0,0,0)).toISOString();
				this.bonCommande.dateFin = new Date(new Date(this.form.get('dateFin').value).setHours(12,0,0,0)).toISOString();
				this.bonCommande.responsable = this.form.get('responsable').value;
				this.bonCommande.adjudicateur = this.form.get('adjudicateur').value;
				this.bonCommande.adresseFacturation = this.form.get('adresseFacturation').value;
				this.bonCommande.titulaire = this.form.get('titulaire').value;
				this.bonCommande.region = this.listRegion.find(x => x.id == this.form.get('region').value); 
				if(this.bonCommande.region == null){
					this.bonCommande.region = this.facade.dataStorageService.getRegion();
				}
				this.bonCommande.references.forEach((e) => {
					e.dateDebut = this.bonCommande.dateDebut
					e.dateFin = this.bonCommande.dateFin
				})

				this.sendForm.emit();
			}
		}
	}

	get marche() {
		return this.form?.get('marche');
	}
	get description() {
		return this.form?.get('description');
	}
	get lot() {
		return this.form?.get('lot');
	}
	get descriptionLot() {
		return this.form.get('descriptionLot');
	}
	get commande() {
		return this.form.get('commande');
	}
	get dateDebut() {
		return this.form.get('dateDebut');
	}
	get dateFin() {
		return this.form.get('dateFin');
	}
	get responsable() {
		return this.form.get('responsable');
	}
	get adjudicateur() {
		return this.form.get('adjudicateur');
	}
	get adresseFacturation() {
		return this.form.get('adresseFacturation');
	}
	get titulaire() {
		return this.form.get('titulaire');
	}
	get services() {
		return this.form.get('services');
	}
	get region() {
		return this.form.get('region');
	}
	get referencesPrestations() {
		return this.form.get('references') as FormArray;
	}
	get servicesBonCommande() {
		return this.form.get('services') as FormArray;
	}

	onAddPrestation() {
		this.referencesPrestations.push(this.fb.group({
			reference: '',
			description: '',
			cible: '',
			quantite: '',
			prix: '',
			unite: ''
		}));
		console.log(this.form.get('references').value);
	}
	
	removePrestation(index:number)
	{
		console.log(index);
		(this.form.get('references') as FormArray).removeAt(index)
	}

	isServiceCheck(spec: Service): boolean {
		return this.listSelectedService?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	updateSelectedService(e: any, spe: Service) {
		if (e.target.checked) {
			if (!this.listSelectedService.some((z) => z.id === spe.id)) {
				this.listSelectedService.push(spe);
			}
		} else {
			if (this.listSelectedService.some((z) => z.id === spe.id)) {
				this.listSelectedService = this.listSelectedService.filter(
					(z) => z.id !== spe.id
				);
			}
		}
		const newListBonCommandeService = [];
		this.listSelectedService.forEach(f => {
			const list: BonCommandeService[] = [];
			this.listSelectedBonCommandeService.forEach(h => {
				if(h.service.id === f.id)list.push(h);
			});
			if(list != null && list.length > 0){
				newListBonCommandeService.push(list[0]);
			}else{
				newListBonCommandeService.push(new BonCommandeService({service: f, pourcentageCharge: null}));
			}
		})
		
		this.listSelectedBonCommandeService = newListBonCommandeService;

		this.clearFormArray(this.form.get('services') as FormArray);

		for (let bon of this.listSelectedBonCommandeService) {
			let service: FormControl = new FormControl();
			let pourcentageCharge: FormControl = new FormControl('');
			service.setValue(bon.service);
			pourcentageCharge.setValue(bon.pourcentageCharge);
			(this.form.get('services') as FormArray).push(new FormGroup({
				service: service,
				pourcentageCharge: pourcentageCharge
			}));
		}
	}

	clearFormArray = (formArray: FormArray) => {
		while (formArray.length !== 0) {
		  formArray.removeAt(0)
		}
	}

}
